<script lang="ts" setup>
import ListArticles from "~/components/articles/ListArticles.vue";

definePageMeta({
    layout: "no-container",
});
</script>

<template>
    <div>
        <ListArticles />
    </div>
</template>

<style scoped></style>
